import { MarketoProgramObject, NewParentObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type ParentCreationResponse = {
    result: string;
}

type UseCreateNewParentCampaignResponse = [
    (data: NewParentObject) => Promise<ParentCreationResponse | null>,
    {
        value?: ParentCreationResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useCreateNewParentCampaign = (): UseCreateNewParentCampaignResponse => {
    
    const [post, postState] = usePost<ParentCreationResponse, NewParentObject>({
        url: `parent-campaigns/create-new-parent-campaign`
    })

    const createNewParent = async (
        data : NewParentObject
    ) : Promise<ParentCreationResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [createNewParent, postState];
};